import { render, staticRenderFns } from "./SelectDropdown.vue?vue&type=template&id=54f3c60d&scoped=true"
import script from "./SelectDropdown.vue?vue&type=script&lang=js"
export * from "./SelectDropdown.vue?vue&type=script&lang=js"
import style0 from "./SelectDropdown.vue?vue&type=style&index=0&id=54f3c60d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f3c60d",
  null
  
)

export default component.exports